import OperatingModeLookupModelBase from '../_generated/modelBases/operating-mode-lookup-model-base';

export default class OperatingModeLookupModel extends OperatingModeLookupModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
